/* ../src/components/TransferTokens.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	space,
	toggle_class
} from "svelte/internal";

import { validateAddress } from "@taquito/utils";
import { MichelsonMap } from "@taquito/taquito";
import store from "../store";
import config from "../config";

function create_else_block(ctx) {
	let i;

	return {
		c() {
			i = element("i");
			attr(i, "class", "icon far fa-thumbs-up fa-lg");
			toggle_class(i, "success", /*success*/ ctx[2]);
			toggle_class(i, "error", /*error*/ ctx[3]);
			toggle_class(i, "disabled", !/*validAddress*/ ctx[4]);
		},
		m(target, anchor) {
			insert(target, i, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*success*/ 4) {
				toggle_class(i, "success", /*success*/ ctx[2]);
			}

			if (dirty & /*error*/ 8) {
				toggle_class(i, "error", /*error*/ ctx[3]);
			}

			if (dirty & /*validAddress*/ 16) {
				toggle_class(i, "disabled", !/*validAddress*/ ctx[4]);
			}
		},
		d(detaching) {
			if (detaching) detach(i);
		}
	};
}

// (226:4) {#if loading}
function create_if_block(ctx) {
	let i;

	return {
		c() {
			i = element("i");
			attr(i, "class", "fas fa-atom fa-lg fa-spin");
		},
		m(target, anchor) {
			insert(target, i, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(i);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let div0;
	let input;
	let input_value_value;
	let t;
	let button;
	let button_disabled_value;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*loading*/ ctx[1]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			input = element("input");
			t = space();
			button = element("button");
			if_block.c();
			attr(input, "type", "text");
			attr(input, "placeholder", "Recipient's address");
			input.value = input_value_value = /*$store*/ ctx[0].recipientAddress;
			input.disabled = /*loading*/ ctx[1];
			attr(div0, "class", "recipient-container__input svelte-1oq138f");
			attr(button, "id", "transfer-button");
			button.disabled = button_disabled_value = /*loading*/ ctx[1] || /*success*/ ctx[2] || !/*$store*/ ctx[0].recipientAddress || !/*validAddress*/ ctx[4];
			attr(div1, "class", "recipient-container svelte-1oq138f");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, input);
			append(div1, t);
			append(div1, button);
			if_block.m(button, null);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*addRecipientAddress*/ ctx[5]),
					listen(button, "click", /*transferTokens*/ ctx[6])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$store*/ 1 && input_value_value !== (input_value_value = /*$store*/ ctx[0].recipientAddress) && input.value !== input_value_value) {
				input.value = input_value_value;
			}

			if (dirty & /*loading*/ 2) {
				input.disabled = /*loading*/ ctx[1];
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(button, null);
				}
			}

			if (dirty & /*loading, success, $store, validAddress*/ 23 && button_disabled_value !== (button_disabled_value = /*loading*/ ctx[1] || /*success*/ ctx[2] || !/*$store*/ ctx[0].recipientAddress || !/*validAddress*/ ctx[4])) {
				button.disabled = button_disabled_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(0, $store = $$value));
	let { fungibleTokens } = $$props, { nonFungibleTokens } = $$props;
	let loading = false;
	let success = false;
	let error = false;
	let validAddress = false;

	const isAddressValid = address => {
		if (validateAddress(address) === 3) {
			return true;
		} else {
			return false;
		}
	};

	const addRecipientAddress = event => {
		const address = event.target.value;

		if (isAddressValid(address)) {
			$$invalidate(4, validAddress = true);
			store.updateRecipientAddress(address);
		} else {
			$$invalidate(4, validAddress = false);
		}
	};

	const transferTokens = async () => {
		if (isAddressValid($store.recipientAddress)) {
			$$invalidate(1, loading = true);

			// address is valid
			if ($store.tokenType === "fa12") {
				// FA1.2
				// sends transaction to contract
				try {
					const contract = await $store.Tezos.wallet.at(config.fa12[$store.network]);
					const op = await contract.methods.mint($store.recipientAddress, fungibleTokens).send();
					console.log("Tx hash:", op.opHash);
					await op.confirmation();

					// when tx succeeds
					store.updateUserBalance(parseInt($store.userBalance) + parseInt(fungibleTokens));
				} catch(error) {
					console.error(error);
					error = true;
				} finally {
					$$invalidate(1, loading = false);
					$$invalidate(2, success = true);

					setTimeout(
						() => {
							$$invalidate(2, success = false);
							$$invalidate(3, error = false);
						},
						3000
					);
				}
			} else if ($store.tokenType === "fa2_ft") {
				// FA2 FT
				try {
					// sends transaction to contract
					const contract = await $store.Tezos.wallet.at(config.fa2_ft[$store.network]);

					const op = await contract.methods.mint_tokens([
						{
							owner: $store.recipientAddress,
							amount: fungibleTokens
						}
					]).send();

					console.log("Tx hash:", op.opHash);
					await op.confirmation();

					// when tx succeeds
					store.updateUserBalance(parseInt($store.userBalance) + parseInt(fungibleTokens));

					$$invalidate(2, success = true);
				} catch(err) {
					console.error(err);
					$$invalidate(3, error = true);
				} finally {
					$$invalidate(1, loading = false);

					setTimeout(
						() => {
							$$invalidate(2, success = false);
							$$invalidate(3, error = false);
						},
						3000
					);
				}
			} else if ($store.tokenType === "fa2_nft") {
				// FA2 NFT
				try {
					// token data
					const from = $store.userAddress;

					const symbol = "TQT";
					const decimals = 0;
					const extras = new MichelsonMap();
					const contract = await $store.Tezos.wallet.at(config.fa2_ft[$store.network]);
					let batch = $store.Tezos.wallet.batch([]);

					for (let i = 0; i < nonFungibleTokens; i++) {
						// creates unique ID and name
						const tokenId = Math.round(Date.now() * Math.random());

						const name = Math.random().toString(36).substr(2, 9);

						// creates transaction
						batch = batch.withContractCall(contract.methods.mint_tokens(from, tokenId, symbol, name, decimals, extras));
					}

					const batchOp = await batch.send();
					await batchOp.confirmation();

					if (isNaN($store.userBalance)) {
						store.updateUserBalance(nonFungibleTokens);
					} else {
						store.updateUserBalance(+$store.userBalance + +nonFungibleTokens);
					}

					$$invalidate(2, success = true);
				} catch(err) {
					console.error(err);
					$$invalidate(3, error = true);
				} finally {
					$$invalidate(1, loading = false);

					setTimeout(
						() => {
							$$invalidate(2, success = false);
							$$invalidate(3, error = false);
						},
						3000
					);
				}
			} else if ($store.tokenType === "tezzies") {
				// transfer tezzies to address
				const url = process.env.NODE_ENV === "development"
				? `http://localhost:${config.netlifyDevPort}/sendTokens`
				: `https://tezos-tokens-faucet.netlify.app/.netlify/functions/sendTokens`;

				try {
					// checks if last transfer was made more than 30 minutes ago
					if (window.localStorage) {
						const lastTransfer = window.localStorage.getItem("lastTransfer");

						if (lastTransfer && Date.now() < parseInt(lastTransfer) + 30 * 60 * 60 * 1000) {
							throw "New transfers become available after 30 minutes.";
						}
					}

					// sends request
					const response = await fetch(url, {
						body: JSON.stringify({
							address: $store.recipientAddress,
							amount: fungibleTokens
						}),
						method: "POST"
					});

					const data = await response.json();
					console.log(data);

					if (data.res === "success") {
						$$invalidate(2, success = true);

						if (window.localStorage) {
							// prevents people from requesting tokens too often
							window.localStorage.setItem("lastTransfer", Date.now());
						}
					} else {
						$$invalidate(3, error = true);
					}
				} catch(err) {
					console.error(err);
					$$invalidate(3, error = true);
				} finally {
					$$invalidate(1, loading = false);
					document.getElementById("transfer-button").blur();

					setTimeout(
						() => {
							$$invalidate(2, success = false);
							$$invalidate(3, error = false);
						},
						3000
					);
				}
			}
		} else {
			
		} // address is not valid
	};

	$$self.$$set = $$props => {
		if ("fungibleTokens" in $$props) $$invalidate(7, fungibleTokens = $$props.fungibleTokens);
		if ("nonFungibleTokens" in $$props) $$invalidate(8, nonFungibleTokens = $$props.nonFungibleTokens);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$store*/ 1) {
			$: if ($store.recipientAddress) {
				$$invalidate(4, validAddress = isAddressValid($store.recipientAddress));
			}
		}
	};

	return [
		$store,
		loading,
		success,
		error,
		validAddress,
		addRecipientAddress,
		transferTokens,
		fungibleTokens,
		nonFungibleTokens
	];
}

class TransferTokens extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { fungibleTokens: 7, nonFungibleTokens: 8 });
	}
}

export default TransferTokens;